module.exports = __webpack_public_path__ + "static/media/square3.32b0a025.svg";